import { Expose } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsDefined, IsInt, IsString, IsUUID } from "class-validator";
import { v4 as uuid } from "uuid";

import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn } from "../orm";
import { TransformToDate } from "../transformers/transformToDate";

@CDEntity("vehicleModels")
export class VehicleModel extends CDBaseEntity {
    @CDObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @CDColumn()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public makeId: string;

    @CDColumn()
    @IsString()
    @IsDefined()
    @Expose()
    public name: string = "";

    @CDColumn()
    @IsInt()
    @IsDefined()
    @Expose()
    public seatsCount: number;

    @CDColumn()
    @IsBoolean()
    @IsDefined()
    @Expose()
    public isLuxury: boolean = false;

    @CDColumn()
    @IsArray()
    @Expose()
    public approvedForCountryIds: Array<string> = [];

    @CDColumn()
    @IsArray()
    @Expose()
    public luxuryForCountryIds: Array<string> = [];

    @CDColumn()
    @IsDate()
    @Expose()
    @TransformToDate
    public disabledAt?: Date;
}
